export default () => {
  const $steps = $('.steps');

  if ($steps.length === 0) {
    return;
  }

  const $controlsWrapper = $('.steps-controls');

  $steps.slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    autoplay: true,
    autoplaySpeed: 3000,
    adaptiveHeight: false,
    pauseOnDotsHover: true,
    appendDots: $controlsWrapper,
    nextArrow: "<button type='button' class='slider-btn slider-btn--next'><svg class='icon slider-btn__icon' width='36' height='18'><use xlink:href='img/sprite-svg/sprite.svg#arrow'></use></svg></button>",
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: false,
          autoplay: false,
        },
      },
    ],
  });
};
